/**
 * RefundStatusService
 * Service for RefundStatus entity operations
 * Route: api/refund-status
 * Controller: RefundStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RefundStatusService
 * Handles refund status CRUD operations
 * Maps to /api/refund-status endpoint
 */
export class RefundStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RefundStatusService.DEFAULT_SERVICE_PATH,
            basePath: RefundStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate refund status cache
     * POST /api/refund-status/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate refund status cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
RefundStatusService.DEFAULT_SERVICE_PATH = 'payments';
RefundStatusService.BASE_PATH = 'api/refund-status';
//# sourceMappingURL=RefundStatusService.js.map